import { createFileRoute } from "@tanstack/react-router";
import { ManagedTeamsPage } from "@/features/managed-administration/pages/workspace-page";
export const Route = createFileRoute("/_authed/managed/teams")({ component: ManagedTeamsPage });
